import type { AmwayBusinessLinksProps } from '../../../components/AmwayBusinessLinks/AmwayBusinessLinks';
import { ComponentType } from '../../registries/types/propTypes';
import { CMSTransformerDataType } from '../../types/common';

const transformAmwayBusinessLinks = (data: CMSTransformerDataType): AmwayBusinessLinksProps => {
  const amwayBusinessLinks = Array.isArray(data.amway_business_links)
    ? data.amway_business_links[0]
    : data.amway_business_links;
  const quickLinksData = amwayBusinessLinks.items.map((item: CMSTransformerDataType) => ({
    images: item.image.images,
    linkdata: {
      url: item.link.url,
      text: item.link.text,
      target: item.link.target,
    },
  }));
  return {
    componentType: ComponentType.amway_business_links,
    title: amwayBusinessLinks.display_title,
    quickLinksData,
  };
};

export default transformAmwayBusinessLinks;
